// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { PropTypes } from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { slpSubLabels, SLP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/SLP.labels';
import style from '../styles/NewLoadedProductsCount.style';

const NewLoadedProductsCount = (props) => {
  const slpLabels = getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels);

  const ItemLabel = renderLabel(slpLabels.lbl_item, 'lbl_item');

  const ItemsLabel = renderLabel(slpLabels.lbl_items, 'lbl_items');
  const { className, totalProductsCount, breadCrumbs } = props;
  const categories = Array.isArray(breadCrumbs) ? breadCrumbs.splice(1) : null;
  const categoryName =
    categories && categories.length ? categories.map((cat) => cat.displayName).join(': ') : null;
  if (!categoryName || !totalProductsCount) return null;
  return (
    <div className={className}>
      <BodyCopy
        className="new-product-category-text"
        component="span"
        fontSize="fs22"
        fontFamily="secondary"
        fontWeight="extrabold"
      >
        {categoryName}
      </BodyCopy>
      <BodyCopy
        className="new-product-count-text"
        component="span"
        fontSize="fs16"
        fontFamily="secondary"
        fontWeight="medium"
      >
        {`(${totalProductsCount} ${totalProductsCount > 1 ? ItemsLabel : ItemLabel})`}
      </BodyCopy>
    </div>
  );
};

NewLoadedProductsCount.propTypes = {
  className: PropTypes.string,
  totalProductsCount: PropTypes.number,
  breadCrumbs: PropTypes.shape([]).isRequired,
};

NewLoadedProductsCount.defaultProps = {
  className: '',
  totalProductsCount: 0,
};

export default withStyles(NewLoadedProductsCount, style);
export { NewLoadedProductsCount as NewLoadedProductsCountVanilla };
